// extracted by mini-css-extract-plugin
export var centerText = "_4d-8";
export var container = "_4d-0";
export var doughnutContainer = "_4d-7";
export var legend = "_4d-a";
export var legendItemColorDisplay = "_4d-b";
export var legendItemLabel = "_4d-d";
export var legendItemValue = "_4d-c";
export var lg = "_4d-5";
export var maxWidth = "_4d-9";
export var md = "_4d-4";
export var responsive = "_4d-6";
export var sm = "_4d-3";
export var xs = "_4d-2";
export var xxs = "_4d-1";